import { injectGlobal } from "styled-components";
import { typography, colors } from "./";

injectGlobal`
  html {
    height: 100%;
  }

  .menu-button {
    height: 50px;
    width: 50px;
    border-radius: 50%;
    display: none;
    justify-content: center;
    align-items: center;
    box-shadow: -5px 0px 10px rgba(0, 0, 0, 0.15);
    position: fixed;
    z-index: 9999;
    top: 25px;
    left: 22px;
    transform: (-1, 0, 0);
    transform: matrix(-1, 0, 0, 1, 0, 0);

    @media (max-width: 768px)
    {
      display: flex;
    }

    &.menu-close {
      color: #fff;
      background-color: #010101;
    }

    @media (max-width: 639px) {
        top: 8px;
        left: 12px;
        width: 40px;
        height: 40px;
    }

    &.menu-open {
      color: #000;
      background-color: #fff;
    }

  }

  .labelFontWeight700Important label {
    color: black;
    font-size: 14px;
    font-weight: 700 !important;
  }

  .datetime-wrapper-move-left .rdtPicker {
    right: 0px !important;
  }
  .datetime-wrapper-move-right .rdtPicker {
    left: 0px !important;
  }
  .datetime-wrapper-move-up .rdtPicker {
    bottom: 0px !important;
  }
  .datetime-wrapper-move-down .rdtPicker {
    top: 0px !important;
  }


  body {
    font-family: 'Nunito', sans-serif;
    margin: 0;
    font-size: ${typography.fontSizeBody}px;
    line-height: ${typography.lineHeightBody};
    color: ${colors.textPrimary};
    height: 100%;
    background: ${colors.bgMain};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    -webkit-text-size-adjust: 100%;

    > #root {
      display: flex;
      flex: 1;
      height: 100%;
    }
  }

  .fw-500 {
    font-variation-settings:
    'FILL' 0,
    'wght' 500,
    'GRAD' 200,
    'opsz' 48
  }
  ::-webkit-scrollbar-thumb {
    background: #2B3C93;
    border-radius: 10px;
  }

  a {
    color: ${colors.linkPrimary};
    transition: color 0.3s ease;
  }

  a:hover {
    // color: inherit;
    text-decoration: none;
  }

  .text-dark {
    color: ${colors.colorBlack} !important;
  }

  .text-primary {
    color: ${colors.colorPrimary} !important;
  }

  .text-success {
    color: ${colors.colorCoreGreen} !important;
  }

  .text-warning {
    color: ${colors.colorCoreYellow} !important;
  }
  .text-blue {
    color: ${colors.themeBlue} !important;
  }
  /* override */


  .FModal .modal-dialog {
    width: max-content;
    margin: 30px auto;
  }
  .FModal .modal-body {
    padding: 20px;
  }
  // .modal.right .modal-dialog {
	// 	position: fixed;
	// 	margin: auto;
	// 	width: 40%;
  //   min-width: 400px;
	// 	height: 100%;
	// 	-webkit-transform: translate3d(0%, 0, 0);
	// 	    -ms-transform: translate3d(0%, 0, 0);
	// 	     -o-transform: translate3d(0%, 0, 0);
	// 	        transform: translate3d(0%, 0, 0);
	// }

  // .modal.right .modal-content {
	// 	height: 100%;
	// 	// overflow-y: auto;
  //   background: #fff;
	// }

  // .modal.right .modal-body {
	// 	padding: 40px 25px 30px 25px;
  //   max-height: 82%;
  //   height: 100%;
  //   overflow-y: auto;
	// }

  // .modal.right.fade .modal-dialog {
	// 	right: -320px;
	// 	-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
	// 	   -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
	// 	     -o-transition: opacity 0.3s linear, right 0.3s ease-out;
	// 	        transition: opacity 0.3s linear, right 0.3s ease-out;
	// }

	// .modal.right.fade.in .modal-dialog {
  //   top: 0;
	// 	right: 0;
	// }

  .right {
    top: 10px !important;
    left: 0 !important;
  }
  .modal-open .modal {
    overflow-x: hidden;
    overflow-y: hidden;
  }

  .modal {
    // top: 20px;
    bottom: 20px;
    border-radius:20px;
  }

  .modal.fade.in .modal-dialog {
    // top: 20%;
    top: 20px;
    // bottom: 20px;
  }

  .modal.center.fade.in .modal-dialog {
    top: 20%;
    width: 400px;
  }

  .modal.center .modal-body {
		padding: 30px 25px 30px 25px;
	}

  .modal.center label {
    font-weight: 600;
    color: #343434;
    font-size: 18px;
    text-transform: capitalize;
  }

  .modal-backdrop {
    background-color: #30435C;
  } !important

  .modal-backdrop.in {
    opacity: 0.8;
  }

  .modal-dialog {
    // padding-top: 50px;
    padding-buttom: 10px;
    // padding: 50px 0;
    margin: 0 auto;
    // height: 560px;
  }

  .modal-dialog.full {
    width: 85%;
  }

  .overflowNot .modal-body {
    overflow-y: inherit;
  }

  .modal-content {
    border-radius: 20px;
    border: 0;
    box-shadow: 0 2px 10px -3px rgba(0, 0, 0, 0.5);
    // background: ${colors.bgLight};
    height: auto;
  }

  .modal-header {
    padding: 24px 30px;
    height: 70px;
    border: 0;
    border-radius: 20px 20px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    box-shadow: none;
    border-bottom:2px solid #f2f2f2;

    &::before,&::after{
      content: none;
    }
  }

  .modal-title {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 27.28px;
    display: flex;
    align-items: center;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    text-align:left;
    color: #010101;
  }

  .modal-body {
    @media (max-width: 760px )
    {
      max-height: calc(100vh - 160px);
    }
    border-radius: 20px;
    padding: 40px 25px 110px 25px;
    padding: 0;
    max-height: calc(100vh - 110px);
  }

  .cs-modal {
    height: 100vh;
  }

  .custom-modal-dialog-for-chooser-selector {
    height: 90vh;
  }

  .custom-modal-dialog-for-chooser-selector-dialog {
    height: 100%;
  }

  .custom-modal-dialog-for-chooser-selector-content {
    height: 100%;
  }

  .chooserSelector-modal-body {
    height: calc(100% - 70px);
  }

  .import-export-modal-body {
    height: calc(100vh - 110px);
  }

  .import-export-table-container {
    max-height: 80vh;
  }

  .modal-footer {
    padding: 0;
    margin-top: 40px;
    border: none;
  }

  .close {
    font-weight: ${typography.fontWeightLight};
    text-shadow: none;
    color: ${colors.themeBlack};
    opacity: 1;
    //font-size: 34px;
    // line-height: 25px;
    border: 2px solid #010101 !important;
    border-radius: 50px;
    width: 20px;
    height: 20px;
    font-size: 20px;
    margin: 0 auto;
    margin-top: 0 !important;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
  }

  .close:hover {
    opacity: 1;
    color: ${colors.themeBlue};
  }

  /* dropdow */

  .dropdown-menu {
    margin-top: 0 !important;
    border-radius: 5px;
    border: none;
    font-size: ${typography.fontSizeBody}px;
    color: ${colors.textPrimary};
    min-width: 100%;
    box-shadow: 0 5px 15px 1px rgba(0, 0, 0, 0.15);
    padding:0px;
  }

  .header-navigation .dropdown-menu {
    padding:10px;
  }

  .dropdown-menu > span {
    display: block;
  }

  .dropdown-menu li a {
    display: block;
    padding: 3px 10px;
    color: ${colors.textPrimary};
    white-space: nowrap;
    float: none;
    margin: 0;
  }

  .dropdown-menu > li > a {
    color: ${colors.textPrimary};
    font-weight: 500;
  }

  .dropdown-menu > li > a:focus,
  .dropdown-menu > li > a:hover,
  .dropdown-menu li a:focus,
  .dropdown-menu li a:hover {
    color: ${colors.colorCoreDarkGray};
    background: ${colors.bgActive};
    outline: 0;
    cursor: pointer;
  }

  /* tooltip */
  .tooltip {
    // font-family: 'Rubik', sans-serif;
    // font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
    // font-family: 'Nunito', sans-serif;
    font-family: 'Nunito', sans-serif;
  }

  .tooltip-inner {
    max-width:100%;
    text-align:left;
    background-color: ${colors.colorWhite};
    color: ${colors.colorCoreDarkGray};
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.23);
  }

  .tooltip.bottom .tooltip-arrow, {
    border-bottom-color: ${colors.colorWhite};
  }

  .tooltip.top .tooltip-arrow {
    border-top-color: ${colors.colorWhite};
  }

  .tooltip.left .tooltip-arrow {
    border-left-color: ${colors.colorWhite};
  }

  .tooltip.right .tooltip-arrow {
    border-right-color: ${colors.colorWhite};
    border-width: 0px 10px 13px 0;
    margin-top: 0;
    top: 0 !important;
  }

  .tooltip.right .tooltip-inner {
    border-top-left-radius: 0;
  }

  .tooltip.in {
    opacity: 1;
  }

  .tooltip.right {
    padding: 0 5px 0 6px;
  }

  /* popover */

  .popover {
    // font-family: 'Rubik', sans-serif;
    // font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif;
    // font-family: 'Nunito', sans-serif;
    font-family: 'Nunito', sans-serif;
    border: none;
    border-radius: 0;
    font-size: inherit;
    padding: 0;
    color: ${colors.textPrimary};
    font-weight: inherit;
    box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.15);
    max-width: 310px;
  }

  .popover.bottom > .arrow {
    border-bottom-color: ${colors.borderPrimary};
  }

  .popover.bottom > .arrow::after {
    top: 1px;
    border-bottom-color: ${colors.bgLight};
  }

  .popover > .arrow {
    border-width: 10px;
  }

  .popover.top > .arrow {
    bottom: -10px;
    margin-left: -10px;
    border-top-color: ${colors.borderPrimary};
  }

  .popover.top > .arrow::after {
    bottom: 1px;
    border-top-color: ${colors.colorWhite};
  }

  .popover-title {
    display: block;
    border-bottom: 1px solid ${colors.borderPrimary};
    padding: 10px 20px;
    background: ${colors.bgLight};
    font-size: ${typography.fontSizeUppercase}px;
    text-transform: uppercase;
    color: ${colors.colorCoreGray};
    border-radius: 0;
  }

  .popover-content {
    padding: 0;
    position: relative;
    min-width: 260px;
  }

  .popover-content .chrome-picker {
    width: 100% !important;
    box-shadow: none !important;
  }

  .popover-content ul {
    max-height: 280px;
    overflow: auto;
  }

  .popover-content li a i {
    margin-left: 0;
  }

  .popover-template {
    max-width: 405px;
    width: 405px;
    height: 400px;
  }
  .popover-template .popover-content {
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 33px;
  }

  .notification-popover {
    right: 15px;
    max-width: 360px;
  }

  /* select  */

  .Select {
    width: 100%;
  }

  .Select-control {
    width: 100%;
    outline: none;
    height: 40px;
    padding: 0 10px 0px 0px;
    border-radius: 10px !important;
    box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
    color: #010101;
    font-size: 12px;
    outline: 0;
    border: 1px solid #f2f2f2 !important;
  }

  .Select-control:hover {
    cursor: pointer;
    box-shadow: none;
  }



  .Select.is-focused > .Select-control,
  .Select.is-open > .Select-control {
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  .Select.is-focused:not(.is-open) > .Select-control {
    box-shadow: none;
    background: #fff;
    border-color: ${colors.themeBlack};
  }

  .Select.is-focused .Select-input > input {
    padding: 10px 0 12px;
  }

  .Select-placeholder,
  .Select-input,
  .Select--single > .Select-control .Select-value {
    padding-left: 6px;
    padding-right: 10px;
    line-height: normal;
    display: flex;
    align-items: center;
  }

  .Select-input .form-invalid {
    border-bottom: 1px solid #EA475D;
    margin-top: 7px;
    // width: 425% !important;
    margin-left: -22px;
  }

  .Select-clear {
    font-size: ${typography.fontSizeHeading6}px;
    line-height: 1.4;
    margin-top: 1px;
  }

  .Select-clear-zone:hover {
    color: ${colors.colorCoreRed};
  }

  .Select--multi .Select-multi-value-wrapper {
    padding: 0 5px;
  }

  .Select--multi .Select-input {
    margin-left: 2px;
  }

  .Select--multi .Select-value {
    background: #2B3C93;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    // background-color: ${colors.colorPrimary};
    // border-radius: 11px;
    // border: 1px solid ${colors.colorPrimary};
    color: ${colors.colorWhite};
    margin-top: 6px;
    margin-left: 0;
    margin-right: 5px;
    position: relative;
    padding-right: 20px;
  }

  .Select--multi .Select-value-icon {
    display: inline-block;
    vertical-align: middle;
    cursor: pointer;
    width: 20px;
    height: 20px;
    border-radius: 6px;
    position: absolute;
    right: 0;
    top: 0;
    text-align: center;
    line-height: 20px;
    background: rgba(0, 0, 0, 0.1);
    padding: 0;
  }

  .Select--multi .Select-value-icon:hover,
  .Select--multi .Select-value-icon:focus,
  .Select--multi .Select-value-icon:active {
    background-color: rgba(0, 0, 0, 0.2);
    color: ${colors.colorWhite};
  }

  .Select--multi .Select-value-label {
    padding: 2px 10px;
  }

  .Select--multi.has-value .Select-input {
    margin-left: 5px;
  }

  .Select--multi a.Select-value-label {
    color: ${colors.colorPrimaryDark};
  }

  .Select-arrow-zone {
    padding-right: 10px;
  }

  .Select-arrow-zone > .Select-arrow {
    border: none;
    margin-right: 10px;
  }

  .Select .Select-arrow:before {
    font-family: 'Material Symbols Outlined';
    font-size: 20px;
    content: '\\e5cf';
    color: ${colors.colorCoreGray};
  }



  .Select.is-open .Select-arrow:before {
    content: '\\e5ce';
  }

  .Select-menu-outer {
    border: none;
    margin-top: 1px;
    box-shadow: 0 5px 15px 1px rgba(0, 0, 0, 0.15);
  }

  .Select-menu-outer, .Select-option:last-child {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .Select-option-group-label {
    background-color: ${colors.bgLight};
    color: #666;
    border-bottom: 1px solid ${colors.borderPrimary};
    border-top: 1px solid ${colors.borderPrimary};
    font-weight: ${typography.fontWeightMedium};
    text-transform: uppercase;
    padding: 8px 12px;
  }

  .Select-option-group-label ~ .Select-option {
    padding-left: 20px;
  }

  .Select-option-group-label .Select-option-group {
    padding-left: 20px;
  }

  .Select-option {
    padding: 8px 12px;
  }

  .Select-noresults {
    padding: 8px 12px;
  }

  .simple-option .channel-round {
    color: ${colors.colorWhite};
    font-weight: bold;
    width: 20px;
    height: 20px;
    float: right;
    border-radius: 6px;
    background: ${colors.colorCoreYellow};
    text-align: center;
    font-size: 10px;
    line-height: 20px;
    cursor: pointer;
  }

  /* react toggle */

  .react-toggle--checked .react-toggle-track {
    background-color: ${colors.colorCoreGreen} !important;
  }

  .react-toggle-track {
    background-color: #B1B1B1 !important;
    width: 50px !important;
    height: 24px !important;
  }

  .react-toggle-track span {
    display: none;
  }

  .react-toggle-thumb {
    width: 18px !important;
    height: 18px !important;
    top: 3px !important;
    left: 3px !important;
    border:0px !important;
    box-shadow: -2px 0px 6px rgba(0, 0, 0, 0.2);
  }

  .react-toggle--checked .react-toggle-thumb,
  .react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    border-color: ${colors.colorCoreGreen} !important;
    left: 29px !important;
  }

  /* punch card */

  .punch-card .axis path,
  .punch-card .axis line {
    fill: none;
    stroke: ${colors.colorCoreGray};
    stroke-width: 1px;
    shape-rendering: crispEdges;
  }
  .punch-card .axis text {
    font-size: 0.875em;
    fill: ${colors.colorCoreGray};
  }

  /* react datetime */

  .rdtPicker {
    box-shadow: 0 5px 15px -3px rgba(0, 0, 0, 0.15);
    width: 100%;
    border-color: ${colors.colorShadowGray};
    min-width: 200px;
    max-width: 260px;
  }

  .rdtPicker td.rdtToday:before {
    border-bottom: 7px solid ${colors.colorPrimary} !important;
  }

  .rdtPicker td.rdtActive,
  .rdtPicker td.rdtActive:hover {
    background-color: ${colors.colorPrimary} !important;
  }

  .rdtPicker th,
  .rdtPicker tfoot {
    border-color: ${colors.borderPrimary};
  }

  /* editor */
  .RichEditor-editor .public-DraftEditor-content ul {
    padding-left: 25px;
  }

  .RichEditor-editor .public-DraftEditor-content ol {
    padding-left: 25px;
  }

  .RichEditor-editor .public-DraftEditor-content h3 {
    margin-top: 0;
  }

  .RichEditor-editor .RichEditor-blockquote {
    border-left: 5px solid ${colors.borderDarker};
    color: ${colors.colorCoreGray};
    font-style: italic;
    padding: 10px 20px;
  }

  .RichEditor-editor .public-DraftStyleDefault-pre {
    margin-bottom: 0;
  }
  .RichEditor-editor .public-DraftStyleDefault-pre pre {
    padding: 0;
    margin: 0;
    border: 0;
  }

  .RichEditor-hidePlaceholder .public-DraftEditorPlaceholder-root {
    display: none;
  }

  /* mention */
  .draftJsMentionPlugin__mention__29BEd {
    cursor: pointer;
    display: inline-block;
    font-weight: bold;
    padding-left: 2px;
    padding-right: 2px;
    border-radius: 4px;
    text-decoration: none;
  }

  .draftJsMentionPlugin__mention__29BEd:visited {
    cursor: pointer;
    display: inline-block;
    font-weight: bold;
    padding-left: 2px;
    padding-right: 2px;
    text-decoration: none;
  }

  .draftJsMentionPlugin__mention__29BEd:hover {
    outline: 0;
  }

  .draftJsMentionPlugin__mention__29BEd:focus {
    outline: 0;
  }

  .draftJsMentionPlugin__mention__29BEd:active {
    color: ${colors.colorCoreDarkGray};
  }

  .draftJsMentionPlugin__mentionSuggestions__2DWjA {
    position: absolute;
    min-width: 220px;
    width: 100%;
    background: ${colors.colorWhite};
    box-shadow: 0 0 10px -3px rgba(0, 0, 0, 0.5);
    cursor: pointer;
    z-index: 2000;
    box-sizing: border-box;
    transform: scale(0);
    bottom: 100%;
    top: auto !important;
    left: 0 !important;
    max-height: 300px;
    overflow: auto;
  }

  .draftJsMentionPlugin__mentionSuggestionsEntry__3mSwm {
    padding: 5px 10px;
    transition: background-color 0.4s cubic-bezier(0.27, 1.27, 0.48, 0.56);
    font-size: ${typography.fontSizeBody}px;
  }

  .draftJsMentionPlugin__mentionSuggestionsEntry__3mSwm:active {
    background-color: ${colors.borderPrimary};
  }

  .draftJsMentionPlugin__mentionSuggestionsEntryFocused__3LcTd {
    background-color: ${colors.bgUnread};
  }

  .mentioned-person {
    cursor: pointer;
    display: inline-block;
    font-weight: bold;
    padding-left: 2px;
    padding-right: 2px;
    text-decoration: none;
  }

  .mention {
    text-decoration: none;
  }

  .mentionSuggestionsEntryContainer {
    display: flex;
  }

  .mentionSuggestionsEntryContainerRight {
    display: flex;
    padding-left: 8px;
    flex: 1;
    flex-direction: row;
    align-items: center;
  }

  .mentionSuggestionsEntryText,
  .mentionSuggestionsEntryTitle {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mentionSuggestionsEntryText {
    margin-right: 8px;
    font-weight: bold;
  }

  .mentionSuggestionsEntryTitle {
    font-size: 95%;
    color: ${colors.colorCoreGray};
    margin-top: 2px;
  }

  .mentionSuggestionsEntryAvatar {
    display: block;
    width: 22px;
    height: 22px;
    border-radius: 50%;
  }

  /* other */
  .sidebar-accordion {
    border-top: 1px solid ${colors.borderPrimary};
    border-bottom: 1px solid ${colors.borderPrimary};
    margin-bottom: 10px;

    ul {
      padding-top: 0;
      max-height: none;
    }
  }

  .sidebar-accordion .popover-header {
    background: none;
  }

  .sidebar-accordion .popover-list {
    max-height: none;
  }

  /* icon select */

  .icon-option {
    display: flex;
    align-items: center;
  }

  .icon-option i {
    margin-right: 10px;
    font-size: ${typography.fontSizeHeading6}px;
    color: ${colors.colorPrimaryDark};
  }

  /* scrollbar */

  ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    border-radius: 0;
  }

  ::-webkit-scrollbar-thumb {
    //background: rgba(72, 77, 61, .6);
    border-radius: 0;
    border: 1px solid #2B3C93/* ${colors.borderDarker} */;
    background: #2B3C93;
    transform: matrix(1, 0, 0, -1, 0, 0);
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track {
    background: rgba(215, 215, 215, .35);
  }
  .cursorPointer {
    cursor: pointer;
  }


  .ag-theme-alpine {
    border: none;
  }
  .ag-header-cell-label {
    color: #2B3C93;
    font-size: 14px;
    font-weight: 800;
    font-style: normal;
    line-height: 19px;
    font-family: 'Nunito';
    text-transform: uppercase;
  }

  .ag-theme-alpine .ag-header-cell-resize::after {
    width: 0px !important;
  }

  .ag-theme-alpine .ag-header {
    background: none !important;
	border-bottom: none !important;
  }

	.ag-header-container {
		// width: 100% !important;
	}

	.ag-header-row.ag-header-row-column {
		width: 100% !important;
	}

	.ag-header-row.ag-header-row-column-filter {
		width: 100% !important;
	}

  .ag-theme-alpine .ag-cell {
    border: none;
    color: #010101;
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    padding: 10px;
    display: table-cell;
    // font-size: 14px;
    padding: 10px 20px;
    // line-height: normal !important;
    display: flex;
    align-items: center;
  }

  .ag-theme-alpine .ag-header-cell{
    padding-right: 0px !important;
  }

  .ag-theme-alpine .ag-row {
    border: none !important;
  }

  .ag-theme-alpine .ag-root-wrapper {
    border: none !important;
    border-color: #D6D6D6 !important;
  }

  .ag-theme-alpine .ag-header-row:not(:first-child) .ag-header-cell, .ag-theme-alpine .ag-header-row:not(:first-child) .ag-header-group-cell.ag-header-group-cell-with-group {
    border: none !important;
  }

  .ag-header-row-column-filter {
		border-top: 2px solid #F2F2F2;
		border-bottom: 2px solid #F2F2F2;
	}

	.ag-header {
		border-bottom: 2px solid #d9d9d9;
	}

	.ag-header-row-column {
		border-top: 0px;
	}

  .styleTag {
    border-radius: 14px;
    padding: 2px 10px;
    text-transform: capitalize;
    white-space: nowrap;
    font-size: 13px;
    line-height: 1.32857;
    border: none;
    font-weight: 600;
    animation: 0s ease 0s 1 normal none running none;
  }

  .editorClassName.rdw-editor-main {
    border: 1px solid #F1F1F1 !important;
    padding: 5px !important;
    border-radius: 2px !important;
  }

  a#uncontrolled-tab-example-tab-sms, a#uncontrolled-tab-example-tab-email {
    color: ${colors.themeBlack};
    font-weight: 600;
    font-size: 14px;
  }

 .grey-btn{
  font-size: 14px;
  font-weight: 900;
  background: #D9D9D9;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  border: 0;
  padding: 12px 20px;
  padding: 12px 20px;
  line-height: 20px;
  letter-spacing: 0.2em;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  color:#B1B1B1;
  display: inline-flex;
  align-items: center;
  }

  .grey-btn-inverse {
    font-size: 14px;
    background-color: #d3d3d3;
    border-radius: 10px;
    border: 0;
    padding: 12px 20px;
    transition: all 0.2s;
    color: black;
    text-align: center;
    &:hover {
      box-shadow: 0px 1px 2px 2px rgba(0, 0, 0, 0.1);
      background-color: #D9D9D9;
      color: #010203;
    }
  }

// .grey-btn:focus,
// .grey-btn:active
.grey-btn:hover
{
    background: #010101;
    color:#fff;
}

.facebook-btn{
  font-size: 14px;
  font-weight: bold;
  font-weight: 900;
  background: #1877f2;
  font-family: Helvetica, Arial, sans-serif;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  border: 0;
  padding: 15px 20px;
  line-height: 18px;
  letter-spacing: 0.2em;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  color:#FFF;
  display: inline-flex;
  align-items: center;
}


.facebook-btn:hover,
.facebook-btn:focus,
.facebook-btn:active {
    background: #023a82;
    color:#fff;
}
// .facebook-btn {
//   background-color: #1877f2;
//   border: 0;
//   border-radius: 4px;
//   color: #fff;
//   cursor: pointer;
//   font-family: Helvetica, Arial, sans-serif;
//   font-size: 16px;
//   font-weight: bold;
//   height: 40px;
//   padding: 0 24px;
// }




.mouse-block {
  cursor: not-allowed;
}
.blue-btn {
    // width: 110px;
    justify-content: center;
    font-size: 14px;
    font-weight: 900;
    background: #28A6DE;
    border: 0;
    border-radius: 10px;
    padding: 12px 20px !important;
    line-height: 20px;
    letter-spacing: 0.2em;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    color:#fff;
    display: inline-flex;
    align-items: center;
    //z-index:9;
    @media screen and (max-width: 767px){
      z-index:0;
    }
}


.blue-btn:hover
   {
      background: #2B3C93;
      color:#fff;
}

.custom-table th.custom-checkbox, .custom-table td.custom-checkbox{
    display: block !important;
    align-items: center;
}

  .custom-checkbox{
    display: flex !important;
    align-items: center;
  }
  .custom-checkbox label{
    display: inline-flex;
    margin-top: 0px !important;
    margin-bottom: 0px;
  }
  .custom-checkbox span::before{
    background: #FFFFFF;
    border: 1px solid #28A6DE;
    border-radius: 5px;
    top: 0;
    display: block;
  }

  .custom-checkbox + span {
      margin:0px;
      height:18px;
      width:18px;
  }
  .custom-checkbox input:checked + span::before{
      background: #28A6DE;
  }

  .custom-checkbox input:checked + span::after{
        top:50%;
        margin-top:-4px;
  }

  .blue-link{
        font-weight: 500 !important;
        font-size: 14px;
        line-height: 20px;
        text-decoration-line: underline !important;
        color: #28A6DE !important;
  }

  .blue-link:hover,.blue-link:focus{
            text-decoration-line: none;
            color: #2B3C93;
  }

              .custom-formwrapper{
                padding:0px;
              }

              .custom-formcolumn{
                padding:0px;

              }


              .leftauth-text{
                font-weight: 700;
                font-size: 14px;
                line-height: 20px;
                letter-spacing: 0.1em;
                color: #B1B1B1;

            }


            .contentData{
              background:#F9F9F9;
              margin-left:70px;
              // border-radius:30px 0px 0px 30px;
              border-radius: 0.625rem;
              box-shadow: 0px 0px 20px 0px rgb(76 87 125 / 2%);
              position:relative;
              z-index:10;
              min-height: 100%;
            }

            .action-bar{
              margin:20px 20px 0;
            }

            .darkblue-btn{
              background:#2B3C93;
              display:inline-flex;
              font-weight: 500;
              font-size: 14px;
              line-height: 20px;
              color:#FFF;
              align-items:center;
              justify-content: center;
              text-transform: uppercase;
              // background: #28A6DE;
              // box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
              // border-radius: 10px;
              // font-style: normal;
              // color: #FFF !important;
              // font-weight: 900;
              // font-size: 14px;
              // line-height: 20px;
            }
            .right-side-filter{
              background:#2B3C93;
              // background: #4860D9;
              border-radius: 10px 0px 0px 10px;
              position: relative;
              // right: -40px;
              height: 44px;
              width: 100px;
            }

            .right-side-filter:hover{
              background:#4860D9;
              // background: #2B3C93 !important;
              color:#FFF;
            }

            // .darkblue-btn:focus
            .darkblue-btn:hover
             {
              background:#4860D9;
              // background:#2B3C93;
              color:#FFF;
            }

            .darkblue-btn span{
              margin-right:10px;
              font-weight:400;
              font-size:20px;
            }

            .mainbox{
              padding:0px 20px;
            }

            .leftdashboard {
              padding:0px;
              border-right:1px solid #d9d9d9;
              border-radius: 30px 0 0 30px;
              box-shadow: 0px 0px 20px 0px rgb(76 87 125 / 2%);
              position: relative;
            }

            .rightdashboard{
              padding:0px;
            }

            .status{
              padding:10px 40px;
            }

            .tile-status{
              padding: 10px 15px;
            }

            .boxsmall-title {
              font-weight: 700;
              font-size: 16px;
              line-height: 22px;
              display: inline-flex;
              align-items: center;
              letter-spacing: 0.2em;
              text-transform: uppercase;
              color: #010101;
              margin:0px 0px 15px 0px;
              background-color:rgba(40, 166, 222, 0.05);
              padding:5px 15px !important;
              border-radius:5px;
              width:auto !important;
            }
            .blue-title{
              color:#2B3C93 !important;
														margin-left: 10px;
            }
            .padding-left30{
              padding-left:30px;
            }

            .custom-chartbox{

            }

            .call-status-info {
              display:flex;
              justify-content:space-between;
              align-items: center;
              margin-bottom:12px !important;
            }

            .call-status-info .status-title{
              margin-left:0px;
              margin-right:auto;
            }

            .call-status-info img {
              margin:0px;
              margin-right:15px;
            }
            .text-custom{
                font-weight: 700;
                font-size: 14px;
                line-height: 25px;
               // letter-spacing: 0.1em;
                color: #010101;
            }

            .rightdashboard{
              //padding-top:15px;
              padding-bottom:15px;
              padding-left:0px !important;
              padding-right:0px !important;
              // background: #fff;
              border-radius:0px 30px 30px 0px;
            }

            .custom-table{

            }
            .custom-table th{
                text-align:left;
                font-weight: 800;
                font-size: 14px;
                line-height: 19px;
                text-transform: uppercase;
                color: #2B3C93;
            }
            .custom-table td{
              text-align:left;
            }

            .custom-table th:last-child, .custom-table td:last-child{
              text-align:right;
            }

            .table-content{}
            .table-content section{
              background:none;
              border-radius:0px;
            }
            .table-content section > div{
              background:none;
              border-radius:0px;
            }

            .tablemain-box{
              padding:0px 20px;
            }

            .tablemain-innerbox{
              box-shadow:0px 4px 24px rgba(0, 0, 0, 0.10);
              border-radius:20px;
              background:#fff;
              overflow-x:auto;
            }


            .mainaction{
              background:none;
              padding: 0px;
              border: 0;
              align-items:center;
            }

            .mainaction label{
              line-height: 49px;
              font-size: 36px;
              font-weight: 700;
              margin-top: 12px;
              color: #2B3C93;
              letter-spacing: 0.1em;
              margin: 0;
              height: auto;
              display: inline-flex;
            }
            .mainaction button.table-deletebutton{
              display: inline-flex;
              margin-left:15px;
              align-items: center;
              line-height: unset;
              border-radius: 6px;
              padding: 10px;
            }

            .lightbutton-btn-inverse {
              font-family: Nunito;
              background-color: #2B3C93;
              border: 1px solid rgba(43, 60, 147, 0.1);
              border-radius: 10px;
              font-weight: 500;
              font-size: 14px;
              padding: 8px 10px;
              text-transform: capitalize;
              color: #fff;
              transition: all 0.2s ease;
              text-align: center;
              &:hover {
                box-shadow: 0px 1px 2px 1px #00000026;
                background-color: rgba(40, 166, 222, 0.5);
                border: 1px solid rgba(43, 60, 147, 0.1);
                color: #2B3C93;
              }
            }


            .lightbutton-btn{
              font-family: Nunito;
              background: rgba(40, 166, 222, 0.05);
              border: 1px solid rgba(43, 60, 147, 0.1);
              border-radius: 10px;
              display:inline-flex;
              font-weight: 500;
              font-size: 14px !important;
              line-height: 16px;
              color: #2B3C93;
              align-items:center;
              padding: 8px 10px !important;
              text-transform: capitalize;

              .material-symbols-outlined {
                font-variation-settings: 'FILL' 0, 'wght' 500, 'GRAD' 200, 'opsz' 48;
              }
            }
            .redbutton-btn{
              background: #ed5e68;
              border: 1px solid rgba(43, 60, 147, 0.1);
              border-radius: 6px;
              display:inline-flex;
              font-weight: 500;
              font-size: 14px;
              line-height: 16px;
              color: #fff;
              align-items:center;
              padding: 8px 10px;
              text-transform: capitalize;
              gap: 10px;
            }

            .redbutton-btn span:nth-of-type(1) {
              font-size: 20px;
              font-weight:400;
              // margin-right:10px;
            }
            .redbutton-btn:hover{
              background: #e52634;
              border: 1px solid rgba(43, 60, 147, 0.1);
              border-radius: 6px;
              color: #fff;
            }
            .lightbutton-btn span:nth-of-type(1) {
              font-size: 20px;
              font-weight:500;
              margin-right:10px;
            }

            .lightbutton-btn:hover{
              background: #2B3C93 !important;
              border: 1px solid rgba(43, 60, 147, 0.1) !important;
              // border-radius: 6px;
              color: #fff !important;
            }


            .custom-chartbox {

            }

            .custom-chartbox .tablemain-box {
              padding:0px;
            }

            .custom-chartbox .tablemain-box .tablemain-innerbox {
              box-shadow: none;
              border-radius: 0px;
              background: none;

            }


            .header-navigation{

            }
            .header-navigation .badge.badge-custom{
              margin-right:10px;
              display: inline-block;
              min-width: 10px;
              padding: 10px 10px;
              font-size: 14px;
              font-weight: 700;
              line-height: 1;
              color: #fff;
              text-align: center;
              white-space: nowrap;
              vertical-align: middle;
              background:#4860D9;
              border-radius: 6px;

            }

            .custom-table .custom-checkbox label{
              margin-top:5px !important;
            }


            .actionButton{}

            .actionButton > div{ display: flex; align-items:center; justify-content:end;}

            .actionButton span{
              font-size:20px;
            }

            .rowBox{
              padding-top:30px;
            }

            .sound-btn{
              verticalAlign: middle;
               padding: 5px 10px;
                color: #2B3C93;
                border: 1px solid #f2f2f2;
                background: #fff;
                fontWeight: 500
            }

              .sounddelete-btn{
                  verticalAlign: middle;
                  padding: 5px 10px;
                  color: #E34242;
                  border: 1px solid #f2f2f2;
                  background: #fff;
                  fontWeight: 500
              }

            .custom-small-modal .modal-sm{
              width:400px;            }

              // Livemonitor title
                .livemonitor-title{
                  font-family: 'Nunito';
                  font-style: normal;
                  font-weight: 700;
                  font-size: 16px;
                  line-height: 22px;
                  background: #28A6DE;
                  border-radius: 6px;
                  color: #FFFFFF;

                }

// .addClass .cData:after{
//   content:'';
//   position:absolute;
//   top:0px;
//   left:-100px;
//   width:100%;
//   height:100%;
//   background:#000000bf;
//   background-image: url(/images/icons/modal_stream_logo.png);
//   background-repeat: no-repeat;
//   background-size: 461px 598px;
//   background-position: 35% 50%;
//   z-index: 99999;
// }

.filter-btn{
  justify-content: space-between;
  display: flex;
  @media screen and (max-width: 767px){
    top: 45px;
  }
}
.custom-form{
  position:relative:
  z-index:9;
}

.filter-row{
  display:flex;
  align-items:center;
  margin-bottom: 10px;
}

.filter-row label{
  display:inline-flex;
  width:40%;
  margin-bottom: 0px;
}

.filter-row input{
  display:inline-flex;
  width: 100%;
  // height: 40px;
}

.filter-row input[type='text']{
  height: 40px;
  padding-left: 15px;
}

.filter-row .rdt {
  width: 100%;
  display: inline-flex;
}

.filter-row .rdt input {
  width: 100%;
  outline: none;
  height: 40px;
  padding: 0 20px;
  border-radius: 6px;
  box-shadow: 0px 3px 20px rgb(0 0 0 / 10%);
  color: #010101;
  font-size: 12px;
  outline: 0;
  border: 1px solid #f2f2f2;
  background: #fff;
}

.totalcallcount{
//font-family: 'Nunito';
font-style: normal;
font-weight: 900;
font-size: 20px;
line-height: 27px;
text-align: right;

color: #2B3C93;
}


.livemonitorbox .leftdashboard{
  background:#fff;
  padding:0px;
  border-left:1px solid #d9d9d9;
  border-right:0px solid #d9d9d9;
  border-radius:0px 30px 30px 0px;
}

.livemonitorbox .rightdashboard{
  padding-top:15px;
  padding-bottom:15px;
  padding-left:0px !important;
  padding-right:0px !important;
  background: #fff;
  // border-radius:30px 0px 0px 30px;
  border-radius: 0.625rem;
  box-shadow: 0px 0px 20px 0px rgb(76 87 125 / 2%);
}

.livepadding-box{
  padding: 20px;
  background: #fff;
  box-shadow: 0px 4px 24px rgb(0 0 0 / 5%);
  border-radius: 20px;
}

.livepadding-right-box {
  bottom: 0;
  border-radius: 0px;
  height: 100%;
  right: 0;
  overflow: auto;
  padding-top: 20px;
  padding-bottom: 20px;
}

.livetile-title{
//font-family: 'Nunito';
font-style: normal;
font-weight: 700;
font-size: 16px;
line-height: 22px;
/* identical to box height */


/* Dark-Color */

color: #010101;
}

// #root main div > div > div > div {
//   background: #F9F9F9;
//       margin-left: 70px;
//       border-radius: 30px 0px 0px 30px;
//       position: relative;
//       z-index: 10;
//       min-height: 100%;
// }

.cData {
  background: #F9F9F9;
margin-left: 70px;
border-radius: 30px 0 0 30px;
position: relative;
z-index: 10;
min-height: 100%;
}

.filterData {
  background: #f2f2f2;
    border-radius: 20px 0px 0px 20px;
    position: fixed;
    height: 100%;
    width: 400px;
    right: 0px;
    top: 0px;
    z-index: 999;
    box-shadow: -10px 0px 20px rgb(0 0 0 / 10%);
}

.heightClass {
  height: 100%;
  overflow: hidden;
  background: #F9F9F9;
}
.overFlowTheme {
  overflow: auto;

}

.iframe_theme iframe {
  width: 100%;
  height: 97%;
  border: none;
  // padding: 20px;
}
  .grid-container{
  margin: 0 !important;
  }
.custom-table input + span::before {
  background: #FFFFFF;
  border: 1px solid #28A6DE;
  border-radius: 5px;
  top: 0;
  display: block;
}

.custom-table input:checked + span::after {
  top: 50%;
  margin-top: -4px;
}
.custom-table input:checked + span::before {
  background: #28A6DE;
}

.custom-table input + span {
  margin-top: 4.5px;
 }

 .rightContent h2 {
    margin-top: 0px;
    text-align: left;
    font-weight: 800;
    font-size: 32px;
    line-height: 44px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #010101;
 }
 .rightContent p {
    text-align: left;
    letter-spacing: 0.48px;
    color: #95959d;
    font-weight: 300;
    font-size: 16px;
    margin-bottom: 30px;
 }

 .integrationBlueBtn {
    background-color: #28A6DE;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    color: #fff;
    letter-spacing: 0.2em;
    font-weight: 900;
    border: none;
    height: 36px;
    width: 140px;
    font-size:14px;
    font-weight: 700;
    margin: auto;
 }

 .ag-cus-table-title .tabs{
  border:none;
}

.ag-cus-table-title .nav-tabs{
  border:none;
  margin-bottom: 10px;
}

.ag-cus-table-title #uncontrolled-tab-example-tab-1{
  border: none;
}
.ag-cus-table-title #uncontrolled-tab-example-tab-1.active{
  border: none;
  background:purple;
}
.ag-cus-table-title #uncontrolled-tab-example-tab-2{
  border: none;
  margin-left: 16px;
}

.ag-cus-table-title .nav-tabs>li>a{
  color:#fff;
  //font-family: 'Nunito';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  // background-color:blue;
  background: grey;
  background: #f4fbfd;
  color:#000;
  // opacity: 0.05;
  border-radius: 6px;
  outline:none;
}

// .nav-tabs>li.active{
//   color:green;
// }

// .nav-tabs>li>a:hover{
//   background-color:yellow;
// }

.ag-cus-table-title .nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover{
  background-color:#28A6DE !important;
  color:#fff;
  outline:none;
}

.ag-cus-table-title .nav-tabs>li>a:visited{
  color:#fff;
  //font-family: 'Nunito';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  // background-color:blue;
  background: #28A6DE;

  // opacity: 0.05;
  border-radius: 6px;
}

.ag-cus-table-title .nav>li>a:focus, .nav>li>a:hover{
  background-color:gray;
  background: #f4fbfd;
  outline: none;
}

.nameClass {
  display: flex;
  align-items: center;

  label {
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #010101;
    display: flex;
    white-space: nowrap;
    width: 60%;
  }
}

.titleStyle {
  label {
    font-weight: 400;
    font-size: 12px;
    line-height: normal;
    color: #303030;
    // margin-right: 25px;
    text-transform: capitalize;
  }
}
.cnt {
  font-weight: 700;
  font-size: 14px;
  margin-left: 4px;
  margin-top: 4px;
}

.headingStyle {
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #010101;
  margin-top: 0px;
}

// .leftPartColumn {
//   background: #FFFFFF;
//   box-shadow: 0px 4px 24px rgb(0 0 0 / 5%);
//   border-radius: 20px;
//   padding: 16px;
// }

.arrowDesign {
  position: absolute;
  top: 35%;
  left: 47.5%;
  z-index: 999;

  span {
    color: #2B3C93;
    background: #fff;
    border: 1px solid #2B3C93;
    border-radius: 50px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.modal-800w {
  width: 800px;
  margin: auto;
}
.modal-1000w{
  width:1000px;
  margin: auto;
}

.tabDifferentStyle {

  .nav-tabs {
    padding-bottom: 10px;
  }

  .nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover {
    color: #fff;
    background: #28A6DE;
    border-radius: 10px;
    cursor: default;
    border: none;
    border-bottom-color: none;
  }

  .nav>li>a:hover[aria-selected="false"]{
    // background:#2B3C93 !important;
    // color:white;
  }

  .nav-tabs>li>a {
    margin-right: 20px;

    //UserEdit needs 5px margin bottom, so added 5px margin bottom
    margin-bottom: 5px;
    line-height: 1.42857143;
    border: none;
    border-radius: 4px 4px 0 0;
    background: #f4fbfd;
    border-radius: 10px;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #000000;
  }
}

.bgProfileImage {
  background: #F2F2F2;
  box-shadow: 0px 4px 24px rgb(0 0 0 / 5%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  height: 220px;
  width: 200px;
}

.fixLeftPart {
  // bottom: 0;
  // position: fixed;
  // top: 70px;
  background: #FFFFFF;
  border-radius: 0px;
  height: 100%;
  // left: 70px;
}

.box-title {
  background: #f7f7f7;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px;

  h6 {
    font-weight: 700;
    font-size: 10px;
    line-height: 14px;
    text-transform: uppercase;
    color: #010101;
  }
}
.for-background{
  position:relative;
  overflow:hidden;
}
  .for-background:after{
    position:absolute;
    background-image: url('/images/new/slidebar-bg.png');
    z-index: -1;
    content:'';
    bottom:0px;
    right:0px;
    background-repeat:no-repeat;
    background-position:bottom right;
    width:307px;
    height:434px;
    z-index: -1;
    background-size: 80%;

  }
  .tableFixHead {
    overflow-y: auto;
    height: 80%;
  }
  .tableFixHead thead th {
    position: sticky;
    top: 0;
    background: #fff;
  }
  .tableFixHead table {
    border-collapse: collapse;
    width: 100%;
  }
  // .tableFixHead th,
  // .tableFixHead td {
  //   padding: 8px 16px;
  //   border: 1px solid #ccc;
  // }
  // .tableFixHead th {
  //   background: #eee;
  // }

  // dialpag design
  body{
    font-family: 'Nunito', sans-serif;
    scrollbar-color:#2B3C93;
}
.container {
    width: 260px;
}
.left-inbox{
    font-family: 'Nunito', sans-serif;
}

.left-inbox .inbox-content .inbox-header {
    background: rgba(217, 217, 217, 0.5);
    position: relative;
    padding-top: 13px;
}

.left-inbox .inbox-content .inbox-header ul li .user-img .dp {
    border-radius: 32px;
}

.left-inbox .inbox-content .inbox-header ul li .user-img .ellipse {
    position: absolute;
    top: 36px;
    left: 44px;
}

.left-inbox .inbox-content .inbox-header ul {
    list-style-type: none;
    display: flex;
}

.left-inbox .inbox-content .inbox-header ul li .heading {
    list-style-type: none;
    align-items: center;
    padding-left: 4px;
}

.left-inbox .inbox-content .inbox-header ul li .heading h3{
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    text-transform: uppercase;
}

.left-inbox .inbox-content .inbox-header ul li .heading h5{
    font-weight: 500;
    font-size: 11px;
    line-height: 15px;
    color: #B1B1B1;
}

.left-inbox .inbox-content .inbox-header ul li .more-option a {
    background: #FFFFFF;
    border-radius: 5px;
    position: absolute;
    height: 28px;
    width: 27px;
    bottom: 35px;
    right: 7px;
}

.left-inbox .inbox-content .inbox-header ul li .user-img {
    margin: 0px 11px 17px -19px;
}

.left-inbox .inbox-content .inbox-header ul li .more-option a span {
    color: black;
    margin: 2px;
}

.left-inbox .inbox-content .top-content {
    background: rgba(217, 217, 217, 0.2);
    border-radius: 5px;
    display: flex;
    color: #010101;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 10px;
    line-height: 14px;
    align-items: center;
    margin-bottom: 16px;
}

.left-inbox .inbox-content .top-content p {
    margin: 0 0 0 8px;
}

.left-inbox .inbox-content .top-content span {
    color: #1C1B1F;
    padding: 1px;
}

.dm-list ul {
    list-style-type: none;
    display: flex;
    padding: 0;
}

.dm-list ul li .dm-user-img img {
    border-radius: 32px;
    margin-right: 19px;
}

.left-inbox .inbox-content .dm-list ul li .user-details h3 {
    font-weight: 700;
    font-size: 11px;
    line-height: 15px;
    text-transform: uppercase;
    color: #010101;
}

.left-inbox .inbox-content .dm-list ul li .user-details h5{
    font-weight: 500;
    font-size: 10px;
    line-height: 14px;
    color: #B1B1B1;
}

.dm-list ul li .msg-counter a {
    text-decoration: none;
    color: #010101;
    font-weight: 700;
    font-size: 11px;
    line-height: 15px;
    background-color: rgba(40, 166, 222, 0.05);
    border-radius: 5px;
    padding: 5px;
}

.dm-list ul li{
    align-items: center;
}

.left-inbox .inbox-content .dm-list ul li .user-details{
    display: flex;
    flex-direction: column;
}

.left-inbox .inbox-content .channel-list ul li span {
    color: #B1B1B1;
    margin-right: 25px;
}

.left-inbox .inbox-content .channel-list ul {
    list-style-type: none;
    padding: 0;
    display: flex;
}

.left-inbox .inbox-content .channel-list ul li p {
    font-size: 12px;
    line-height: 15px;
    font-style: bold;
    font-weight: 700;
}

.left-inbox .inbox-content .channel-list ul li a{
    text-decoration: none;
    font-weight: 700;
    font-size: 11px;
    color: #010101;
    background-color: rgba(40, 166, 222, 0.05);
    border-radius: 5px;
    padding: 5px;
}
.chatbox .msgpart .img img {
    border-radius: 32px;
    position: relative;
}

.chatbox .msgpart {
    display: flex;
    height: auto;
    align-items: start;
    margin-bottom: 25px;
}

.chatbox .msgpart .user-avtar{
    position: relative;
}

.chatbox .msgpart .user-avtar .status {
position: absolute;
width: 10px;
height: 10px;
right: 0;
top: 60%;

}

.chatbox .msgpart .rchat {
    background: rgba(255, 189, 93, 0.25);
    border-radius: 6px;
    font-size: 14px;
    line-height: 24px;
    font-family: 'Nunito', sans-serif;
    font-weight: 500;
}

.chatbox .msgpart .rchat {
    background: rgba(255, 189, 93, 0.25);
    border-radius: 6px;
    font-size: 14px;
    line-height: 24px;
    font-family: 'Nunito';
    font-weight: 500;
    padding: 8px 8px;
    margin: 0px 0px 0px 16px;
    max-width: 70%;
}

.chatbox .msgpart.reply{

    justify-content: flex-start;
    flex-direction: row-reverse;
}
.chatbox .msgpart.reply .rchat{
    background: rgba(76, 185, 68, 0.2);
    margin: 0px 16px 0 0;
}

.user-avtar {
    width: 40px;
    height: 40px;
    display: inline-flex;
}


.chatbox .msgpart.reply .user-avtar .status{
right: auto;
left: 0px;
}







.chat-header{ display: flex; align-items: stretch; border-bottom: 1px solid #D9D9D9; justify-content: space-between; min-height: 70px; height: 100%;}

/* CHAT HEADER LEFT SECTION*/
.chat-header-left{ display: inline-flex; align-items: center; margin-right: 40px; margin-left: 20px}
.chat-header-left .user-info { margin-left: 10px;}
.chat-header-left .user-info .username{
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    text-transform: uppercase;
    color: #010101;}


.chat-header-left .user-avtar{ width: 50px; border-radius: 50%;}
.chat-header-left .user-avtar img{ border-radius: 50%;}
.chat-header-left .user-info .user-number { font-weight: 500;
    font-size: 11px;
    line-height: 15px;
    display: flex;
    align-items: center;
    color: #B1B1B1; }

/* CHAT HEADER MIDDLE SECTION*/
.chat-header-middle{ display: inline-flex; align-items: center;}
.chat-header-middle .team-info{}
.chat-header-middle .team-info .teamname{font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    text-transform: uppercase;
    color: #010101;}
.chat-header-middle .team-info .team-label{font-weight: 500;
    font-size: 11px;
    line-height: 15px;
    display: flex;
    align-items: center;
    color: #B1B1B1; }


/* CHAT HEADER RIGHT SECTION*/
.chat-header-right{ display: inline-flex; align-items: center;}

.chat-img{ padding: 0px 10px;  }
.chat-img a{
background: #28A6DE;
border-radius: 6px;
display: inline-flex;
padding: 10px 15px;
color: #fff;
text-decoration: none;
}


.time-img{padding: 0px 10px; }
.time-img a{
    background: rgba(40, 166, 222, 0.05);
    border-radius: 6px;
    display: inline-flex;
    padding: 10px 15px;
    color: #1C1B1F;
    text-decoration: none;
    }

.call-img{ border-left: 1px solid #D9D9D9; padding: 0px 10px; height: 100%;
    align-items: center;
    display: inline-flex;}

.call-img a{
    background: #4CB944;
    box-shadow: 0px 0px 25px rgb(0 0 0 / 20%);
    border-radius: 50%;
    display: inline-flex;
    padding: 10px 10px;
    color: #fff;
    text-decoration: none;
    }

    /* MESSAGE SENT SECTION*/

    .sent-msg{ display: flex;height: 95px;background: #FFFFFF 0% 0% no-repeat padding-box;opacity: 1; border-radius: 6px; position: absolute; width: 100%; bottom: 0px; }
    .sent-msg .write-msg{ position:relative; display:  flex; padding: 3px; border-radius: 6px; margin: auto; background-color: #F7F7F7; width: 100%;
        justify-content: space-between;}

    .sent-msg .write-msg textarea.form-control { border: none; background: none;}
    .sent-msg .write-msg input { font-weight: 700; font-size: 16px; line-height: 22px; border: none; top: 934px; color: rgba(1, 1, 1, 1); background-color: #F7F7F7;  padding-left: 21px;}
    .msg-img{display: inline-flex; align-items: center;}


    .msg-img{ display: inline-flex; align-items: center;}
    .msg-img .smiley-img a{padding: 0px 10px; color: #F3BF4B;}
    .msg-img .attach-img a{padding: 0px 10px; color: #000000;}
    .msg-img .send-img a{ background-color: #2B3C93; box-shadow: 0px 0px 25px rgb(0 0 0 / 20%); border-radius: 15%; display: inline-flex; padding: 10px 10px; color: #fff; text-decoration: none;}

    .z-index-999{
      z-index: 999;
    }

.chips-common-style{
  line-height: normal;
  border-radius: 5px;
  padding:2px 10px;
}
.Mute-box{
  background: rgba(48, 48, 48, 0.2);
  color: rgba(48, 48, 48, 1);
}
.Failed-box{
  background: rgba(255, 122, 41, 0.2);
  color: rgba(255, 122, 41, 1);
}
.Transfer-box{
  background: rgba(1, 97, 237, 0.2);
  color: rgba(17, 112, 228, 1);
}
.Connected-box{
  background: rgba(203, 7, 148, 0.2);
  color: rgba(203, 7, 148, 1);
}
.Ringing-box{
  background: rgba(9, 173, 149, 0.2);
  color: rgba(9, 173, 149, 1);
}
.ACW-box{
  background: rgba(72, 96, 217, 0.2);
  color: rgba(72, 96, 217, 1);
}
.red-box{
background: rgba(232, 38, 70, 0.2);
color: rgba(227, 66, 66, 1);
}
.info-box{
background: #d1ecf1;
color: #0c5460;
}
.yellow-box{
background: rgba(255, 189, 93, 0.2);
color: rgba(255, 189, 93, 1);
}
.blue-box{
background: #cce5ff;
color: #004085;
}
.green-box{
background: rgba(76, 185, 68, 0.2);
color: rgba(76, 185, 68, 1);
}
.dark-box{
background: rgba(177, 177, 177, 0.2);
color: rgba(177, 177, 177, 1);
}
.transparent-box{
background: #fefefe;
color: #818182;
}
.white-box{
background: #fff2;
color: black;
}
.responsive-header-wrapper img{
  display:none;
}
@media (max-width: 767px )
{
  .cData{
    margin-left: 0px;
    border-radius: 10px;
  }
  .responsive-header-wrapper{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .responsive-header-wrapper img{
    display:block;
    width: 5%
  }
  .mainbox{
    padding:0px 0px !important;
    margin-left: 0px !important;
    margin-top: 55px;
  }
}

.main-content-wrapper{
    margin-left: 15px;
    margin-right: 15px;
    background-color:#fff;
    overflow: visible;
}

.clear-button-react-select-plus{
  color: #2B3C93;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 19px;
}

// .css-4ljt47-MenuList{
//   height: 180px;
// }

.Select--multi .Select-value {
  word-break: break-all;
}

#error-input-business-hour {
  border-bottom: 1px solid #ea475d;
}

.or {
  display: flex;
  flex-direction: row;
  // margin-bottom: 1.2rem;
  align-items: center;
}

.or .bar {
  flex: auto;
  border: none;
  height: 1px;
  background: rgb(217, 217, 217);
}

.or span {
  color: #ccc;
  padding: 0 0.8rem;
}

//CSS for Organization page - super admin

.line-height-10{
	line-height: 10px;
  }

  .tenant-box > div{
	display: flex;
	//justify-content: space-between;
	flex-wrap: wrap;
  }
  .tenant-box > div > div {
	width: 33.33%;
  }

  @media only screen and (min-width:1600px){
	.tenant-box > div > div {
		width: 25%;
	  }
  }

  @media only screen and (max-width: 710px){
    .remove-text-on-small-screen{
      display: none;
    }
  }


	@media (max-width: 992px) {
    .fixed-filter-btn{
      width: 58px;
    }
		.remove-text-on-925px {
			display: none;
		}
		.lightbutton-btn span:nth-of-type(1) {
			margin: 0px;
		}
    // .lightbutton-btn {
    //   margin: 0;
    // }
	}
  .width-100-below-500{
    width: 47% !important;
  }
  @media (max-width: 500px){
    .display-block-below-500px{
      display: block;
    }
    .flex-column-reverse-below-500px{
      flex-direction: column-reverse;
      align-items: flex-start;
    }
    .width-100-below-500{
      width: 100% !important;
    }
  }
  @media (max-width: 768px){
    .team-add-modal{
      width: 80vw;
      margin: 0 auto;
    }
  }

  // MEDIA QUERIES UNDER 576px
  @media (max-width: 576px) {
    .flex-column-under-sm {
      flex-direction: column;
    }
    .px-0-under-sm {
      padding-left: 0;
      padding-right: 0;
    }
   }

   // hide back button
   .btn-back {
    display: none;
   }

  // .material-symbols-outlined {
  //   font-variation-settings: 'wght' 300;
  // }
   }
`;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/styles/global-styles.js